import { getSalesforceCases } from 'actions/salesforce'
import DriveSidebar from 'components/layout/DriveSidebar'
import { Breadcrumb } from 'components/misc/Breadcrumb'
import { useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import { useSelector } from 'react-redux'
import Page from 'rui/widgets/Page'
import { getLastUpdatedOpenCase } from 'util/salesforce'
import CaseStatus from '../CaseStatus'
import { useLocalization } from 'localization'

const AppealStatusPage: React.FC = () => {
  const { t } = useLocalization()
  const isWebView = useSelector<any, boolean>((state) => state.config.isWebview)

  const [appealSummary, setAppealSummary] = useState<any>(null)

  useEffect(() => {
    getSalesforceCases().then((data) => {
      const mostRecentAppeal = getLastUpdatedOpenCase(data, 'appeal')
      setAppealSummary(mostRecentAppeal || null)
    })
  }, [])

  return (
    <Page sidebar={<DriveSidebar />}>
      <Helmet>
        <title>{t('dweb_dashboard_salesforce_appeal_status')}</title>
      </Helmet>
      {!isWebView && (
        <Breadcrumb
          items={[
            { label: t('dweb_common_my_profile'), linkTo: '/dashboard' },
            { label: t('dweb_dashboard_account_status'), linkTo: 'account-status' },
            { label: t('dweb_dashboard_salesforce_appeal_status') },
          ]}
        />
      )}
      <CaseStatus summary={appealSummary} type={'appeal'} />
    </Page>
  )
}

export default AppealStatusPage
